import { useTran } from "@/hooks";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const INACTIVE_BADGE_CLASSNAME =
  "h-4 rounded-md border-amber-500 px-1 py-0 text-xs font-medium text-amber-700 dark:border-amber-500/70 dark:text-amber-400";

const getInactiveYear = (inactiveDate) => {
  if (!inactiveDate) return null;
  const date =
    inactiveDate instanceof Date ? inactiveDate : new Date(inactiveDate);
  const year = date.getFullYear();
  return Number.isFinite(year) ? year : null;
};

const getInactiveStatusLabel = (t, { inactiveByChildren, year }) => {
  if (inactiveByChildren || !year) return null;

  return t("common.inactiveSince", {
    year,
    defaultValue: `Inactive since ${year}`,
  });
};

const OrgStatusTag = ({
  status,
  className,
  inactiveDate = null,
  inactiveByChildren = false,
}) => {
  const { t } = useTran();
  if ((status || "active") !== "inactive") return null;

  const year = getInactiveYear(inactiveDate);
  const label = getInactiveStatusLabel(t, { inactiveByChildren, year });

  if (!label) return null;

  return (
    <Badge
      variant="outline"
      className={cn(INACTIVE_BADGE_CLASSNAME, className)}
    >
      {label}
    </Badge>
  );
};

export default OrgStatusTag;
